import script from "./AppCartItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppCartItem.vue?vue&type=script&lang=ts&setup=true"

import "./AppCartItem.vue?vue&type=style&index=0&id=4bcb6906&lang=scss"

const __exports__ = script;

export default __exports__